module.exports = __webpack_public_path__ + "img/Hard to Open.edfcad3d.png";